import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface Movie {
  id: number;
  title: string;
  slug: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  duration: string;
  views: string;
  isHot?: boolean;
  isNew?: boolean;
}

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  const categoryName = categories.find((c) => c.slug === movie.category)?.name || movie.category;

  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 hover:border-primary-500/40 transition-all duration-300 hover:scale-[1.02]"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex items-center gap-1.5 flex-wrap">
          {movie.isHot && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
              热播
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
              新片
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/80 backdrop-blur-sm px-2 py-0.5 rounded-md">
          <i className="ri-star-fill text-primary-500 text-xs"></i>
          <span className="text-xs font-semibold text-foreground-950">{movie.rating}</span>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span>{movie.year}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
            <span>{movie.duration}</span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-md">
            {categoryName}
          </span>
          <span className="text-xs text-foreground-500">{movie.views}次播放</span>
        </div>
      </div>
    </Link>
  );
}